import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html'
})
export class CardsComponent implements OnInit {

  @Input() data;
  @Input() icon;
  @Input() iconclass;
  @Input() cols = '1';
  @Input() specialEmpty = false;

  constructor() { }

  ngOnInit() {
  }

}
